import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PersonService } from 'app/services/models/person.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-worker-dialog',
  templateUrl: './create-worker-dialog.component.html',
  styleUrls: ['./create-worker-dialog.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class CreateWorkerDialogComponent implements OnInit {
  personForm: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    private personService:PersonService,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private router:Router
  ) { }

  date = new Date();

  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
  };

  public dateTimeEndOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
  };

  public dateTimeLeaveJobOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
  };

  ngOnInit(): void {
    this.personForm = this.fb.group({
      name: [null, Validators.required],
      lastName: [null, Validators.required],
      mission: [null, Validators.required],
      phoneNumber: [null],
      mail: [null],
      address: [null],
      birthDay: [null],
      startDate: [null],
      workingStatus: [null],
      department: [null],
      emergencyContact: [null],
      tc: [null, [Validators.maxLength(11)]],
      wage: [0, Validators.min(0)],
      leaveJob:[null],
      workingDays:[null,[Validators.min(1), Validators.max(7)]],
      workingDayHours:[null,[Validators.min(1), Validators.max(24)]]
    });
  }
  
  closeModal() {
    this.activeModal.close(false);
  }

  async onSumbit(){
    if(this.personForm.valid){
      console.log(this.personForm.value);
      const response = await this.personService.createWorker(this.personForm.value);
      if(response.status == true){
        this.toastrService.success(response.message);
   
        this.personService.sendEvent(true);
        this.closeModal();
      }else{
        this.toastrService.error(response.message);
      }
    }
  }
}
